// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___lPkZQ","m-signature-pad--body":"styles__m-signature-pad--body___WLSsQ","m-signature-pad--footer":"styles__m-signature-pad--footer___MdLaU","description":"styles__description___N_axu","button":"styles__button___pOUDy","clear":"styles__clear___3-CEm","save":"styles__save___1fyeD","m-signature-pad":"styles__m-signature-pad___eUC3B","github":"styles__github___388bM","card":"styles__card___6Kuq0","altColor":"styles__altColor___1_OWG","inactive":"styles__inactive___22Krw"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/Card/styles.scss
// module id = un+S
// module chunks = client